import React, { useState } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { Link as RouterLink } from "react-router-dom";
import ReactJson from "react-json-view";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import ResponsiveGrid from "../_components/ResponsiveGrid";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { dataActions } from "../_actions";
import FiltersGrid from "../_components/FiltersGrid";
import PageWithHeader from "../_components/PageWithHeader";
import { isObject } from "lodash";

export default function FeaturePage({ match }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  return (
    <PageWithHeader title="AHCO Feature List">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Typography
              component="h2"
              variant="h6"
              color="primary"
              gutterBottom
            >
              AHCOFeatureList
            </Typography>
            <AHCOFeatureList id={match.params.ahco_id} />
          </Paper>
        </Grid>
      </Grid>
    </PageWithHeader>
  );
}

function AHCOFeatureList(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const item = useSelector((state) => state.data.auctionHouseCompanies);
  const features =
    item && item.items && item.items[0] ? item.items[0].view_features : [];
  const AHCOName =
    item && item.items && item.items[0] ? item.items[0].full_name : "Unknown";

  const [getData, setGetData] = useState(false);
  const [featuresFiltered, setFeaturesFiltered] = useState(features);

  const [availableFilters, setAvailableFilters] = useState([
    {
      name: "Feature Name",
      field: "feature_name",
      operator: "like",
      value: "",
      type: "text",
      default: "",
    },
  ]);

  const columns = [
    {
      width: 4,
      title: "Feature Name",
      field: "feature_name",
    },
    {
      width: 2,
      title: "Source",
      field: "source",
    },
    {
      width: 6,
      title: "Feature Value",
      field: "feature_value",
      dataRender: (item) => <FeatureValue item={item} />,
    },
  ];

  useEffect(() => {
    getNewData();
  }, []);

  useEffect(() => {
    if (getData === true) {
      setGetData(false);
      getNewData();
    }
  }, [getData]);

  useEffect(() => {
    const filteredFeatures = features.filter((feature) => {
      let hasMatch = false;
      availableFilters.map((filter) => {
        const key = filter.field;
        if (feature[key].includes(filter.value)) {
          hasMatch = true;
        }
      });
      return hasMatch;
    });
    setFeaturesFiltered(filteredFeatures);
  }, [availableFilters]);

  const getNewData = () => {
    dispatch(
      dataActions.getData(
        "auctionHouseCompanies",
        {
          filters: [
            {
              field: "id",
              operator: "eq",
              value: props.id,
            },
          ],
        },
        () => {
          console.log("stuff", { item, features });
        }
      )
    );
  };

  const handleFilterChange = (newFilter) => {
    const newFilters = availableFilters.map((filter) => {
      if (filter.field !== newFilter.field) return filter; // not the droid we're looking for, return unchanged
      filter.value = newFilter.value;
      return filter;
    });
    setAvailableFilters(newFilters);
  };

  return (
    <>
      <Typography variant="h4">{AHCOName}</Typography>
      <FiltersGrid
        availableFilters={availableFilters}
        onChange={handleFilterChange}
      />
      <ResponsiveGrid
        usePagination={false}
        loading={item.loading}
        columns={columns}
        data={featuresFiltered}
      />
    </>
  );
}

function FeatureValue(props) {
  const fType = props.item.feature_data_type;
  const fValue = props.item.feature_value;

  if (fType === "boolean") {
    return fValue === true ? "TRUE" : "FALSE";
  }
  if (fType === "map") {
    return <ReactJson src={fValue} collapsed={true} />;
  }
  if (typeof fValue === "string") {
    return fValue;
  }

  return "not yet supported";
}

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
}));
